export default {
    patientList: "Patientenliste",
  };
  